export const localizedStrings = {
  // Menu slide-in
  'menu-btn-open': {
    type: 'aria-label',
    fr: 'Ouvrir le menu',
    en: 'Open menu',
    de: 'Menü öffnen',
    it: 'Apri menu',
  },
  'menu-btn-close': {
    type: 'aria-label',
    fr: 'Fermer le menu',
    en: 'Close menu',
    de: 'Menü schließen',
    it: 'Chiudi menu',
  },
  'menu-nav-btn-text-audioguide': {
    type: 'aria-label',
    fr: "Retour à l'audioguide",
    en: 'Back to the audioguide',
    de: 'Zurück zum Audioguide',
    it: 'Torna all\'audioguida',
  },
  'menu-nav-btn-text-audioguide': {
    fr: "Retour à l'audioguide",
    en: 'Back to the audioguide',
    de: 'Zurück zum Audioguide',
    it: 'Torna all\'audioguida',
  },
  'menu-nav-btn-about': {
    type: 'aria-label',
    fr: 'À propos',
    en: 'About',
    de: 'Über',
    it: 'Informazioni',
  },
  'menu-nav-btn-text-about': {
    fr: 'À propos',
    en: 'About',
    de: 'Über',
    it: 'Informazioni',
  },
  'menu-nav-btn-credits': {
    type: 'aria-label',
    fr: 'Crédits',
    en: 'Credits',
    de: 'Credits',
    it: 'Crediti',
  },
  'menu-nav-btn-text-credits': {
    fr: 'Crédits',
    en: 'Credits',
    de: 'Credits',
    it: 'Crediti',
  },
  'menu-language-select-title': {
    fr: 'Choix de la langue',
    en: 'Language selection',
    de: 'Sprachauswahl',
    it: 'Selezione della lingua',
  },

  // Audioguide page
  'audioguide-title': {
    fr: 'Audioguide',
    en: 'Audioguide',
    de: 'Audioguide',
    it: 'Audioguida',
  },
  'audioguide-transcription-title': {
    fr: 'Transcription',
    en: 'Transcription',
    de: 'Transkription',
    it: 'Trascrizione',
  },
  'transcription-btn-toggle': {
    type: 'aria-label',
    fr: 'Afficher la transcription',
    en: 'Show transcription',
    de: 'Transkription anzeigen',
    it: 'Mostra trascrizione',
  },
  'audioguide-player-loading-text': {
    // Also used for player title
    fr: 'Chargement...',
    en: 'Loading...',
    de: 'Laden...',
    it: 'Caricamento...',
  },
  'play-controls': {
    type: 'aria-label',
    fr: 'Contrôles de lecture',
    en: 'Audio playback controls',
    de: 'Wiedergabesteuerung',
    it: 'Controlli di riproduzione',
  },
  'seekForward': {
    type: 'aria-label',
    fr: 'Avancer de 5 secondes',
    en: 'Seek forward 5 seconds',
    de: '5 Sekunden vorwärts springen',
    it: 'Avanza di 5 secondi',
  },
  'seekBackward': {
    type: 'aria-label',
    fr: 'Reculer de 5 secondes',
    en: 'Seek backward 5 seconds',
    de: '5 Sekunden zurückspringen',
    it: 'Riavvolgi di 5 secondi',
  },
  'play-pause': {
    type: 'aria-label',
    fr: 'Lecture/Pause',
    en: 'Play/Pause',
    de: 'Wiedergabe/Pause',
    it: 'Riproduci/Pausa',
  },

  // About page
  'about-title': {
    fr: 'À propos',
    en: 'About',
    de: 'Über',
    it: 'Informazioni',
  },

  // Credits page
  'credits-title': {
    fr: 'Crédits',
    en: 'Credits',
    de: 'Credits',
    it: 'Crediti',
  },

};
